import { useContext } from 'react';

import { AuthContext } from './AuthenticationProvider';

export const useAuthContext = () => {
  const ctx = useContext(AuthContext);

  if (ctx == null) {
    throw new Error('Wrap app with AuthenticationProvider');
  }

  return ctx;
};
